import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PieceType } from 'src/app/core/models/piece/piece-type-modele-enum';

export class UrlUtils {
  public static onClickEmbbeded(event: any, baseUrl: string, queryParams: any, router: Router, newTab = false) {
    if (event.ctrlKey || newTab) {
      const urlEnd = router.serializeUrl(router.createUrlTree(['/embedded'], { queryParams }));

      window.open(`${baseUrl}${urlEnd}`, '_blank');
    } else {
      router.navigateByUrl('/blank', { skipLocationChange: true }).then((a) => {
        if (a) {
          router.navigate(['/embedded'], { queryParams });
        }
      });
    }
  }
  public static getParentUrl(route: ActivatedRouteSnapshot, url = ''): string {
    if (route.parent.url.length) {
      url = url ? `${route.parent.url[0].toString()}/${url}` : `${route.parent.url[0].toString()}`;
      return this.getParentUrl(route.parent, url);
    } else {
      return url;
    }
  }

  public static getActiviteEditUrl(activiteId: number) {
    return `/Activites/ActiviteEdit/Edit?activiteId=${activiteId}`;
  }

  public static getPieceEditUrl(pieceId: number) {
    return `/GestionCom/PiecesEdit/Edit/${pieceId}`;
  }

  public static getReglementClientEditUrl(rglId: number) {
    return `/Reglements/ReglementClientSaisie/Edit?reglementId=${rglId}`;
  }

  public static getRemiseClientEditUrl(remId: number) {
    return `/Reglements/RemiseClient/Edit?remiseId=${remId}`;
  }

  public static getFactureCreateUrl() {
    return `/GestionCom/PiecesEdit/Create?pieceType=FC`;
  }

  public static getFactureFinaleCreateUrl(devisId: number) {
    return `/GestionCom/PiecesEdit/Create?mode=TRANSFORMATION&fromId=${devisId}&pieceType=FACTURE_CLIENT&solder=true&pctTransformation=100,00`;
  }

  public static getFactureAcompteCreateUrl(devisId: number) {
    return `/GestionCom/PiecesEdit/Create?mode=TRANSFORMATION&fromId=${devisId}&pieceType=ACOMPTE_CLIENT&solder=true&pctTransformation=100,00`;
  }

  public static getFactureSituationCreateUrl(devisId: number) {
    return `/GestionCom/PiecesEdit/Create?mode=TRANSFORMATION&fromId=${devisId}&pieceType=SITUATION_CLIENT&solder=true&pctTransformation=100,00`;
  }

  public static getEcritureUrl(ecritureId: number) {
    return `/Comptabilite/Ecritures/Index?ecritureAppliIdOpe0=egal&ecritureAppliIdVal0=${ecritureId}`;
  }

  public static getActiviteCreateUrl() {
    return `/Activites/ActiviteEdit/Create`;
  }

  public static getArticleStandardEditUrl(articleStandardId: number) {
    return `/GestionCom/ArticlesStandards/Edit?astId=${articleStandardId}`;
  }

  public static getArticleStandardCreateUrl() {
    return `/Gestioncom/ArticlesStandards/Create`;
  }

  public static getClientEditUrl(clientId: number) {
    return `client/edit/${clientId}`;
  }

  public static getEncaissementEditUrl(encaissementId: number) {
    return `encaissement/edit/${encaissementId}`;
  }

  public static getModeleGcEditUrl(modeleGcId: number) {
    return `/GestionCom/PiecesEdit/Edit?id=${modeleGcId}`;
  }

  public static getModeleGcCreateUrl() {
    return `/Gestioncom/PiecesEdit/Create?pieceType=MO`;
  }

  public static getPieceFromModeleGcUrl(modeleGcId: number, pieceType: PieceType, dupliqueFichier: boolean, dupliqueMemo: boolean) {
    return `/Gestioncom/PiecesEdit/Create?mode=DUPLICATION&fromid=${modeleGcId}&pieceType=${pieceType}&dupliquerFichiersJoints=${dupliqueFichier}&dupliquerMemoSuivi=${dupliqueMemo}`;
  }

  public static getModeleGcOpenUrl(modeleGcId: number) {
    return `/GestionCom/PiecesEdit/Open?id=${modeleGcId}`;
  }

  public static getFFFromFacturxEditUrl(pieceId: number) {
    return `/AchatsFournisseurs/PieceEdit/Edit/?pieceId=${pieceId}`;
  }

  public static getDeclarationTvaUrl(dtvId: number) {
    return `/Reglements/DeclarationTvaSaisie/Edit2/?declarationTvaId=${dtvId}&fromSkip=0`;
  }

  public static getNoteFraisEditUrl(pieceId: number) {
    return `/AchatsFrais/NoteFraisEdit/Edit/?noteFraisId=${pieceId}`;
  }
}
